import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Polygon, Path, G } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';
import { PALETTE } from '../../../constants';

function AccordionMinusIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;


  return (

    <Svg
      {...svgProps}
      viewBox="0 0 20 20">
      <Path id="minus" fill-rule="evenodd" fill={color || PALETTE.primaryActive} transform="translate(0,-6)" d="m0 6h15v4h-15z" />
    </Svg>

  );
}


AccordionMinusIcon.defaultProps = {
  height: 20,
  width: 20,
};

AccordionMinusIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

export default pure(AccordionMinusIcon);
